import './SessionInformation.css';
import { NotificationManager} from 'react-notifications'
import {  useState } from "react";

const SessionInformation = ({sessionData,roleUser}) => {
    const link = 'https://frontend-ta-wiyata.netlify.app/precall/';
    let ketentuanDiskusiList = []
    let pemicuDiskusiList = []
    let instruksiFasilitatorList = []
    const [shareClicked, setShareClicked] = useState(false)
    if(sessionData['ketentuan_diskusi'] !== null){
        ketentuanDiskusiList = sessionData['ketentuan_diskusi'].split('\r\n')
    }
    if(sessionData['instruksi_fasilitator'] !== null){
        instruksiFasilitatorList = sessionData['instruksi_fasilitator'].split('\r\n')
    }
    if(sessionData['pemicu_diskusi'] !== null ){
        pemicuDiskusiList = sessionData['pemicu_diskusi'].split('\r\n')
    }
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    var date = new Date(sessionData['waktu_mulai'].split(" ")[0]);
    date = date.toLocaleDateString('en-GB', options)
    let file = sessionData['file_materi_diskusi'].split("/")
    file = sessionData['file_materi_diskusi'].split("/")[file.length-1]
    const handleCopy = (role) =>{
        NotificationManager.success('Link for '+ role+' has been copied', 'Success');
        setShareClicked(false)
    }
    return (
        <div class={roleUser === 'HOST' ? "sesi__inner max-height--host" : "sesi__inner max-height--student"}>
            <div class="session__text-header">
                <div class="text--course">{sessionData['mata_kuliah']}</div>
                <div class="session__share-link">
                    <div class="session__share-link--button" onClick={() =>{setShareClicked(!shareClicked)}}>
                        <div>Share</div>
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.71875 8.94775L12.5 13.7186L17.2813 8.94775L18.75 10.4165L12.5 16.6665L6.25 10.4165L7.71875 8.94775Z" fill="#165A7C"/>
                        </svg>
                    </div>
                    {   shareClicked ? 
                        <div class={ roleUser === 'HOST' ? "session__share-link--popup popup--host" : "session__share-link--popup"}>
                            {roleUser === 'HOST' ?
                                <p onClick={() =>{navigator.clipboard.writeText(link+sessionData['link_lobby_room_host']);handleCopy("Host")}}>Link For Host</p>
                            :null}
                            <p onClick={() =>{navigator.clipboard.writeText(link+sessionData['link_lobby_room_partisipan']);handleCopy("Student")}}>Link For Student</p>
                        </div> :null
                    }
                </div>
            </div>
            <p>{date}</p>
            <p>{sessionData['topik_diskusi']} ({sessionData['waktu_mulai'].split(" ")[1]} - {sessionData['waktu_akhir'].split(" ")[1]})</p>
            {pemicuDiskusiList.length > 0 ? 
                <div>
                    {pemicuDiskusiList.map((pemicu,index)=>
                        <p className="text__discusion-question" key={index}>{pemicu}</p>
                    )}
                </div>
            :null}
            {ketentuanDiskusiList.length > 0 ? 
                <div>
                    <p>Discussion terms:</p>
                    {ketentuanDiskusiList.map((ketentuan,index)=>
                        <p key={index}>{ketentuan}</p>
                    )}
                </div>
            :null}
            {sessionData['file_materi_diskusi'] !== '/media/null' ?          
                <p><a href={'https://backend-ta-wiyata.herokuapp.com'+sessionData['file_materi_diskusi']} target="_blank" >{sessionData['file_materi_diskusi'].split("/")[3]}</a></p>
            : null}
            {roleUser === 'HOST' && instruksiFasilitatorList.length > 0  ? 
                <div>
                    <p>Instructions for facilitator:</p>
                    {instruksiFasilitatorList.map((instruksi,index)=>
                    <p key={index}>{instruksi}</p>
                    )}
                </div>
            : null }
        </div>
	);
}
 
export default SessionInformation;

